import React from "react";
import Images from "../../assests/Images";
import { useLocation, useNavigate } from "react-router-dom";

const Navbar = ({ content }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  return (
    <>
      <nav className="navSection px-3 py-2">
        <div className="d-flex align-items-center gap-2">
          <div
            className="image_block"
            onClick={() => {
              navigate(-1);
            }}
          >
            <img
              src={Images?.backIcon}
              alt="no-image"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </div>
          <h4 className="navbar_heading mt-2 pt-1">{content}</h4>
        </div>
        <div className="image_block">
          <img
            src={Images?.userProfile}
            alt="no-image"
            className="image_icon"
          />
        </div>
      </nav>
    </>
  );
};

export default Navbar;
